import { AnyAction } from 'redux';
import { Params } from 'src/api';
import { createEntityActions } from 'src/store/entities/actions';

/**
 * The value for the NONE variant is required for the reducer selection in index.ts
 * The other values are expected to be the projection string as required by the API (coincides with reducer selection)
 */
export enum Projection {
    NONE = 'default',
    FULL = 'full',
    DETAILS = 'details',
    RECOMMENDED = 'recommended',
}

export const getProjectionParam = (projection: Projection): Params | undefined =>
    projection !== Projection.NONE ? { projection } : undefined;

type Instantiable = new (...args: any[]) => any;

interface ProjectionTypeMap {
    [projection: string]: Instantiable;
}

/**
 * Holding detailed description of an Entity.
 */
export default class EntityDescription {
    public repository: string;
    public name: string;
    public reducer: string;
    public actions: EntityActions;
    public projectionsTypeMap: ProjectionTypeMap;

    constructor(repository: string, name?: string, reducer?: string) {
        this.repository = repository;
        this.name = name ? name : repository.toUpperCase();
        this.reducer = reducer ? reducer : repository;
        this.actions = createEntityActions(this);
        this.projectionsTypeMap = {};
    }
}

export interface EntityActions {
    request: (projection?: string) => AnyAction;
    successFetch: (response: any, projection?: string, mergeItems?: boolean) => AnyAction;
    notModified: (projection?: string) => AnyAction;
    successDelete: (response: any, projection?: string) => AnyAction;
    failure: (error: any, projection?: string) => AnyAction;
}
